import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'https://naus-backend.onrender.com/api';

const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('adminToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('adminToken');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const authApi = {
  login: (credentials) => api.post('/admin/login', credentials),
  forgotPassword: (email) => api.post('/admin-management/forgot-password', { email }),
  resetPassword: (token, password) => api.post('/admin-management/reset-password', { token, password })
};

export const applicationsApi = {
  getAll: () => api.get('/admin/applications'),
  getById: (id) => api.get(`/admin/applications/${id}`),
  updateStatus: (id, status) => api.patch(`/admin/applications/${id}`, { status })
};

export const adminManagementApi = {
  getAll: (params) => api.get('/admin-management/admins', { params }),
  getById: (id) => api.get(`/admin-management/admins/${id}`),
  create: (data) => api.post('/admin-management/admins', data),
  update: (id, data) => api.put(`/admin-management/admins/${id}`, data),
  delete: (id) => api.delete(`/admin-management/admins/${id}`),
  getProfile: () => api.get('/admin-management/profile'),
  updateProfile: (data) => api.put('/admin-management/profile', data),
  changePassword: (data) => api.post('/admin-management/change-password', data)
};

export const membersApi = {
  getAll: (params) => api.get('/members', { params }),
  getById: (id) => api.get(`/members/${id}`),
  update: (id, data) => api.put(`/members/${id}`, data),
  toggleStatus: (id) => api.patch(`/members/${id}/status`),
  search: (query) => api.get('/members/search', { params: { q: query } }),
  createExisting: (data) => api.post('/admin/existing-members', data),
  delete: (id) => api.delete(`/members/${id}`)
};

